import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from './Card';

const Timeline = ({ isBackground = false }) => {
  const { t } = useTranslation();
  const events = [
    { title: t('sections.timeline.events.ceremony'), icon: '⛪' },
    { title: t('sections.timeline.events.cocktail'), icon: '🥂' },
    { title: t('sections.timeline.events.dinner'), icon: '🍽️' },
    { title: t('sections.timeline.events.dance'), icon: '🎉' },
  ];

  return (
    <div className={`w-full h-full flex items-center justify-center py-2 ${isBackground ? 'bg-castle-cream-100' : ''}`}>
      <div className="relative w-full px-1">
        <div className="flex justify-between items-center relative">
          {events.map((event, index) => (
            <div key={index} className="flex flex-col items-center relative z-10">
              <span className="text-sm font-bold text-beast-brown-800 mb-1">{event.time}</span>
              <div className="w-8 h-8 bg-belle-blue-600 rounded-full flex items-center justify-center mt-5">
                <span className="text-lg text-white">{event.icon}</span>
              </div>
              <p className="text-sm font-semibold text-beast-brown-800 mt-1 text-center w-16">{event.title}</p>
            </div>
          ))}
         
          <div className="absolute top-[42px] left-0 w-full h-0.5 bg-belle-blue-600 -z-0" />
        </div>
      </div>
    </div>
  );
};

const DayDetails = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-8" id="details">
      <div className="max-w-4xl mx-auto px-4 py-2">
        <h2 className="text-4xl font-bold font-cursive text-beast-brown-800 mb-6 text-center">
          {t('dayDetails.title')}
        </h2>
        <div className="flex flex-wrap justify-center gap-6">
          {/* Card 1 - Ceremonia */}
          <div className="w-full sm:w-[47%]">
            <Card
              imageUrl="/fantasy.jpg"
              title={t('sections.ceremony.title')}
              subtitle={t('sections.ceremony.subtitle')}
              path="/ceremony"
            />
          </div>
          
          {/* Card 2 - Banquete */}
          <div className="w-full sm:w-[47%]">
            <Card
              imageUrl="/H_00336_001.webp"
              title={t('sections.banquet.title')}
              subtitle={t('sections.banquet.subtitle')}
              path="/banquet"
            />
          </div>
          
          {/* Card 3 - Timeline */}
          <div className="w-full sm:w-[47%]">
            <Card
              title={t('sections.timeline.title', 'Horario')}
              customContent={<Timeline />}
              backgroundContent={<Timeline isBackground={true} />}
              path="/timeline"
              isTimeline={true}
            />
          </div>

          {/* Card 4 - Mapa */}
          <div className="w-full sm:w-[47%]">
            <Card
              imageUrl="/map-background.png"
              title={t('sections.map.title')}
              path="/map"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DayDetails;
